<input
  type="text"
  [mask]="this.postalCodeMaskType(this.companyFormComponent.model.country)"
  [placeholder]="this.postalCodeMaskType(this.companyFormComponent.model.country)"
  class="form-control"
  [dropSpecialCharacters]="false"
  [formControl]="formControl"
  [formlyAttributes]="field"
/>
